module.exports = __webpack_public_path__ + "img/u302.5e554716.svg";